/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Breadcrumbs from '../components/Breadcrumbs';
import Cart from '../components/Cart';
import CategoriesWidget from '../components/CategoriesWidget';
import Checkout from '../components/Checkout';
import CommonApi from '../components/CommonApi';
import DefaultRSSComponent from '../components/DefaultRSSComponent';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HeaderInfo from '../components/HeaderInfo';
import Help from '../components/Help';
import Helper from '../components/Helper';
import Home from '../components/Home';
import Login from '../components/Login';
import Main from '../components/Main';
import Menu from '../components/Menu';
import MyOrders from '../components/MyOrders';
import MyOrdersSummary from '../components/MyOrdersSummary';
import MyUsers from '../components/MyUsers';
import NewsWidget from '../components/NewsWidget';
import Product from '../components/Product';
import ProductsList from '../components/ProductsList';
import Profile from '../components/Profile';
import PromotionWidget from '../components/PromotionWidget';
import ResetPassword from '../components/ResetPassword';
import SourcedRSSComponent from '../components/SourcedRSSComponent';
import UploadHistoryWidget from '../components/UploadHistoryWidget';
import UploadWidget from '../components/UploadWidget';
import YoutubeEmbed from '../components/YoutubeEmbed';

const components = new Map();
components.set('Breadcrumbs', Breadcrumbs);
components.set('Cart', Cart);
components.set('CategoriesWidget', CategoriesWidget);
components.set('Checkout', Checkout);
components.set('CommonApi', CommonApi);
components.set('DefaultRSSComponent', DefaultRSSComponent);
components.set('Footer', Footer);
components.set('Header', Header);
components.set('HeaderInfo', HeaderInfo);
components.set('Help', Help);
components.set('Helper', Helper);
components.set('Home', Home);
components.set('Login', Login);
components.set('Main', Main);
components.set('Menu', Menu);
components.set('MyOrders', MyOrders);
components.set('MyOrdersSummary', MyOrdersSummary);
components.set('MyUsers', MyUsers);
components.set('NewsWidget', NewsWidget);
components.set('Product', Product);
components.set('ProductsList', ProductsList);
components.set('Profile', Profile);
components.set('PromotionWidget', PromotionWidget);
components.set('ResetPassword', ResetPassword);
components.set('SourcedRSSComponent', SourcedRSSComponent);
components.set('UploadHistoryWidget', UploadHistoryWidget);
components.set('UploadWidget', UploadWidget);
components.set('YoutubeEmbed', YoutubeEmbed);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
